import { memo, type PropsWithChildren, useCallback, useMemo, useState } from "react"

import { TextConfirmationDialog } from "../../components/Dialogs/TextConfirmationDialog"
import { TextConfirmationDialogContext, type TextConfirmationDialogContextType } from "./context"
import { setUnsafeUseTextConfirmationDialog } from "./globals"
import type { TextConfirmationDialogConfig } from "./typings"

export const TextConfirmationDialogProvider = memo((props: PropsWithChildren) => {
	const { children } = props
	const [config, setConfig] = useState<TextConfirmationDialogConfig | null>(null)

	const close = useCallback(() => {
		setConfig(null)
	}, [])

	const open = useCallback<TextConfirmationDialogContextType>(
		(open) => {
			setConfig(open(close))
		},
		[close],
	)

	const contextValue = useMemo(() => {
		setUnsafeUseTextConfirmationDialog(open)

		return open
	}, [open])

	return (
		<TextConfirmationDialogContext.Provider value={contextValue}>
			{children}
			{!!config && <TextConfirmationDialog open={!!config} {...config} />}
		</TextConfirmationDialogContext.Provider>
	)
})
TextConfirmationDialogProvider.displayName = "IssueDialogProvider"
